import moment from 'moment';

function EventWidgetsCtrl($scope, $state, $stateParams, $q, sdkVenueService, eventService, sdkUtils, dateUtilsService, alertService, managementUserService, organizationService, mapperService) { //eslint-disable-line
  const vm = this;

  vm.currentDateUTC = moment.utc();
  vm.loading = true;
  vm.venueId = $stateParams.venueId;

  const dataPromises = [
    $scope.venuePromise,
    $scope.eventPromise
  ];

  $q.all(dataPromises)
    .then(results => {
      vm.venue = results[0];
      vm.event = results[1];

      const mappedEvent = mapperService.mapEventToUI(results[1]);

      vm.eventForm = mappedEvent;

      vm.loading = false;
    });
}

EventWidgetsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'organizationService',
  'mapperService'
];

export default EventWidgetsCtrl;



// WEBPACK FOOTER //
// ./src/components/eventWidgets/eventWidgetsCtrl.js